import { AppState } from '../rootReducer'

export const getFilters = (state: AppState) => state.filters.filters
